package com.macrofocus.eflux.network.physical

import com.macrofocus.eflux.data.PowerFlowParser
import com.macrofocus.eflux.network.logical.LogicalNetwork
import com.macrofocus.eflux.network.logical.logicalBranchIdOf
import com.macrofocus.eflux.network.logical.logicalBusIdOf
import org.molap.dataframe.DataFrame
import org.molap.network.AbstractNetwork
import kotlin.time.measureTime

class PhysicalNetwork(
    parser: PowerFlowParser,
    coordinates: DataFrame<Int, String, Any?>? = null,
    itcm: DataFrame<Int, String, Any?>? = null
) : AbstractNetwork<Bus, Branch>() {
    private val busDataFrame = parser.busDataFrame

    //    private var loadDataFrame = parser.loadDataFrame
//    private var generatorDataFrame = parser.generatorDataFrame
    private val branchDataFrame = parser.branchDataFrame

    //    private var transformerDataFrame = parser.transformerDataFrame
    private val zoneDataFrame = parser.zoneDataFrame

    init {
        if (busDataFrame != null) {
            val iZoneMap = if (zoneDataFrame != null) {
                zoneDataFrame.rows().associateBy({ it.i }, { Zone(it) })
            } else {
                emptyMap()
            }

            val iCoordinatesMap = coordinates?.rows()
                ?.filter { coordinates.getValueAt(it, "NAME_KURZ") != null }
                ?.associateBy(
                    { coordinates.getValueAt(it, "NAME_KURZ") as String },
                    { coordinates.getValueAt(it, "NAME_NUMBER") as String? })

            val iITCMMap = itcm?.rows()
                ?.filter { itcm.getValueAt(it, "raw_busbar_name_left7_i-raw_busbar_name_left7_j-ckt") != null }
                ?.associateBy(
                    { itcm.getValueAt(it, "raw_busbar_name_left7_i-raw_busbar_name_left7_j-ckt") as String },
                    { itcm.getValueAt(it, "FullName ITCM") as String? })

            val iBusMap = busDataFrame.rows()
                .associateBy({ it.i }, {
                    val longName = iCoordinatesMap?.get(it.name.padEnd(6).left6().trim().removeSuffix("_")) ?: it.name
                    Bus(it, iZoneMap[it.zone], longName)
                })

            iBusMap.values.forEach { addNode(it) }

            if (branchDataFrame != null) {
                branchDataFrame.rows().forEach {
                    val from = iBusMap[it.i]
                    val to = iBusMap[it.j]
                    if (from != null && to != null) {
                        val id = logicalBranchIdOf(logicalBusIdOf(from.id), logicalBusIdOf(to.id), it.ckt)
                        val name = iITCMMap?.get(id.name)
                        val fullName = if (name != null) {
                            name
                        } else {
                            val reverseId = logicalBranchIdOf(logicalBusIdOf(to.id), logicalBusIdOf(from.id), it.ckt)
                            val name = iITCMMap?.get(reverseId.name)
                            if (name != null) {
                                name
                            } else {
                                id.name
                            }
                        }

                        addUndirectedEdge(from, to, Branch(from, to, it, fullName))
                    } else {
                        // ToDo: report error
                    }
                }
            } else {
                println("No branch data record!")
            }
        } else {
            println("No bus data record!")
        }
    }

    override fun getFrom(link: Branch): Bus = link.from

    override fun getTo(link: Branch): Bus = link.to

    val logical: LogicalNetwork by lazy {
        val logical: LogicalNetwork
            with(measureTime {
                logical =  LogicalNetwork(this)
            }) {
                println("Logical network created in $this")
            }
        logical
    }
}